import {Button} from 'antd'
import {getId, getType} from 'apis/model/base'
import logParams from 'helpers/logParams'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {UseFollow} from 'views/Server/ServerContainer'
import {LayoutContext} from "../layouts/Default/LayoutContext";
import classNames from "classnames";
import {NullAsDefault, renderIfElse} from "../../views/Shared";
import {useSelectEntities} from "../../redux/entities/useSelectEntities";
import {channelSchema, groupSchema, organizationSchema, userSchema} from "../../apis/schema";
import {ifThenElseMultipleConditions} from "../../helpers/ifThenElseMultipleConditions";
import {eventSchema} from "../../apis/schema/event";

export const FollowButton = ({
                                 item = {},
                                 renderLabel = NullAsDefault,
                                 size = 'small',
                                 children
                             }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const id = getId(item)
    const type = getType(item)
    const _item = useSelectEntities(getId(item),
        ifThenElseMultipleConditions(
            channelSchema,
            type === 'organization', organizationSchema,
            type === 'group', groupSchema,
            type === 'user', userSchema,
            type === 'event', eventSchema,
        )
        , item)
    const {follow_status = false} = _item

    const title = follow_status ? t('following') : t('follow')

    let height, fontSize, padding
    switch (size) {
        case 'small':
            height = 21
            fontSize = 11
            padding = '0 12px'
            break;
        case 'medium':
            height = 28
            fontSize = 14
            padding = '4px 16px'
            break;
        case 'large':
            height = 36
            fontSize = 16
            padding = '6px 18px'
            break;
        default:
            height = 32
            fontSize = 15
            padding = '4px 14px'
            break;
    }

    if (!_.has(_item, 'follow_status')) {
        return null
    }

    return (
        <UseFollow
            follow_status={follow_status}
            owner_id={id}
            owner_type={type}>
            {(handleFollow) => {
                if (children) {
                    return logParams(children)(follow_status, handleFollow, title)
                }

                return renderIfElse(
                    renderLabel !== NullAsDefault,
                    <span
                        style={{ fontSize: 12 }}
                        className="ml-1 font-medium text-link italic tracking-wider leading-4 whitespace-no-wrap cursor-pointer"
                        onClick={() => handleFollow()}>
                        {renderLabel(_item)}
                    </span>,
                    <Button
                        size={size}
                        color={!!follow_status ? "default" : "primary"}
                        variant={!!follow_status ? "filled" : "solid"}
                        onClick={() => handleFollow()}
                        style={{height: height, padding: padding, fontSize: fontSize}}
                        className={classNames(
                            "flex flex-center button-rounded-full no-border leading-tight",
                            !!follow_status ? 'text-color-300' : 'font-medium text-white'
                        )}>
                        <span className="italic leading-tight tracking-wider">{title}</span>
                    </Button>
                )
            }}
        </UseFollow>
    )
}



